// extracted by mini-css-extract-plugin
module.exports = {"container":"FocusGoalSettings_container__1W6Lp","focusInfo":"FocusGoalSettings_focusInfo__1OG10","focusInfoText":"FocusGoalSettings_focusInfoText__1eArX"};